<template>
  <div>    
     <div class="row">
        <div class="col-md-12">
            <ul style="padding-left: 0px; margin-bottom: 0px; padding-bottom: 5px;">
                <li v-for="(item, indice) in lsttop5pro" :key="indice" class="li-item-card-dash" style="height: 15px;">
                    <div class="row">
                        <div class="col-8">
                            <h5 class="txt-item-card-dash-top5-desc" v-bind:title="item.descricao">{{ item.idproduto }} - {{ item.descricao }}</h5>
                        </div>
                        <div class="col-4 text-right valconainer">
                            <template v-if="parseInt(visualizartop5) === 0">
                                <h5 class="txt-item-card-dash-top5-val">{{ mtdformatavalordecimal(parseFloat(item.totalitem)) }} ({{ mtdformatavalordecimal(parseFloat(item.totalitem) / parseFloat(item.totalgeralvendas) * 100, '') }}%)</h5>
                            </template>
                            <template v-else>
                                <h5 v-if="mtdisdecimal(parseFloat(item.qtditem))" class="txt-item-card-dash-top5-val" style="float: right;">{{ mtdformataqtddecimal(parseFloat(item.qtditem)) }} ({{ mtdformatavalordecimal(parseFloat(parseFloat(item.qtditem)) / parseFloat(item.qtdgeralvendas) * 100, '') }}%)</h5>
                                <h5 v-else class="txt-item-card-dash-top5-val" style="float: right;">{{ item.qtditem }} ({{ mtdformatavalordecimal(parseFloat(item.qtditem) / parseFloat(item.qtdgeralvendas) * 100, '') }}%)</h5>                                                        
                            </template>
                        </div>
                    </div>                                                    
                </li>
            </ul>                                            
        </div>
    </div>    
  </div>
</template>

<script>
import util from '../../utilitarios/util';
export default {
  name: "BarChartCard",
  data : function name(params) {
    return {
       lsttop5pro    : [],
      visualizartop5 : 0,
      sttop5provl    : [],
      lsttop5proqtd  : [],
      lsttop5pro     : [],
      usuariologado   : this.$store.state.usuario,
    }
   
  },
  props: [
     'utodasfiliais',
     'idfilialmeta',
     'pdtini',
     'pdtfim',
     'lstfiliais',
     'qtdnotaspendentes',
  ],
  methods:{
        mtdformatavalordecimal(valor){
				  return util.formatarvalor(valor, '');
        },
      
       mtdresultadofaturamento(){
          var vself           = this;
        
          vself.$emit('handlerLoader', true);
          let periodo         = '"' + util.InverterData(this.pdtini) + ' 00:00:00" and "' + util.InverterData(this.pdtfim) + ' 23:59:59"';
      
 
          let parametros      = [
              {parametro: 'idclientesac', valor : window.localStorage.getItem('idcliente')},
              {parametro: 'op',           valor : 'dash'},
              {parametro: 'idusuario',    valor : vself.$store.state.usuario.id},                    
              {parametro: 'periodo',      valor : periodo},
              {parametro: 'usuariologado',valor : JSON.stringify(vself.usuariologado)},
              {parametro: 'filiais',      valor : JSON.stringify(vself.lstfiliais)},
              {parametro: 'diasemana',    valor : util.diasemanaintmysql()},
              {parametro: 'filtrotarefas',valor : ''},//' and t.sttarefa=0'},
              {parametro: 'patharquivos', valor : ''},
          ];
          let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/dashboard.php');
          retorno.then(function (response) {
              
              vself.lsttop5provl            = response.data.top5provl;
              vself.lsttop5proqtd           = response.data.top5proqtd;
              vself.lsttop5pro              = vself.lsttop5provl;
           
              vself.$emit('handlerLoader', false);										
          }).catch(function (response) {
              vself.lsttop5provl            = [];
              vself.lsttop5proqtd           = [];
              vself.lsttop5pro              = [];
              //loader.hide();
              vself.$emit('handlerLoader', false);	
          });                
      },
  },
  mounted(){
    this.mtdresultadofaturamento();
  },
  computed:{
            
  },
}
</script>
